module.exports = {
          srcSet: __webpack_public_path__ + "f9eb32ebb210277ab5bf9b5e6b9a0b97-400.png"+" 400w",
          images:[ {path: __webpack_public_path__ + "f9eb32ebb210277ab5bf9b5e6b9a0b97-400.png",width: 400,height: 84}],
          src: __webpack_public_path__ + "f9eb32ebb210277ab5bf9b5e6b9a0b97-400.png",
          toString:function(){return __webpack_public_path__ + "f9eb32ebb210277ab5bf9b5e6b9a0b97-400.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAACCAYAAABhYU3QAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAWklEQVR4nGOQl5CskJOQjJeXkMyWlJJ2kBAVyVUSEnSVk5TKkJeQzJSXlEqTl5BMYJCXkBRWlJCU4JGWlcrjYJPOsAmwY/OMM1XnZpOXk1UQkpeQlJGXkBQHABEoDD/6AC8UAAAAAElFTkSuQmCC",
          width: 400,
          height: 84
        }